<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />
                <a-button
                    class="item"
                    type="primary"
                    @click="on_create"
                    icon="plus"
                    v-if="permissible.indexOf('order_trademark.create') > -1"
                ></a-button>
                <a-divider type="vertical" class="item" />

                <a-popover
                    title="选择销售"
                    :getPopupContainer="(trigger) => trigger.parentNode"
                    style="width:120px;"
                    v-if="basic_data_user.length"
                >
                    <template slot="content">
                        <div v-if="basic_data_user.length" style="max-width:480px;margin-bottom:12px">
                            <a-checkable-tag
                                class="r-checkbox checkbox-tag"
                                v-for="item in basic_data_user"
                                :key="item.id"
                                :checked="search_user_ids.some((v) => v == item.id)"
                                @change="(e) => on_mutli_field(e, item.id, 'search_user_ids')"
                                >{{ item.name }}</a-checkable-tag
                            >
                        </div>

                        <a-button
                            type="primary"
                            size="small"
                            @click="on_mutli_search('search_user_ids', 'user_id')"
                            style="margin-right:12px"
                            >搜索</a-button
                        >
                        <a-button size="small" @click="on_reset_field('user_id')">清除搜索</a-button>
                    </template>
                    <a-button class="item slice" :ghost="!!search_user_ids.length" :type="!!search_user_ids.length ? 'primary' : 'default'">
                        选择销售
                        <a-icon type="caret-down" />
                    </a-button>
                </a-popover>

                <a-range-picker
                    class="item"
                    @change="on_created_change"
                    v-model="created_date"
                    :disabledDate="(v) => v >= moment()"
                    value-format="YYYY-MM-DD"
                />
            </div>

            <div class="right-items">
                <a-input-search placeholder="搜索订单号、商标号" enter-button @search="on_search" class="item" v-model="wd" />
            </div>
        </div>

        <div class="main">
            <a-tabs default-active-key="" v-model="search_step" @change="(e) => on_field_change(e, 'step')">
                <a-tab-pane key="" tab="全部订单"> </a-tab-pane>
                <a-tab-pane key="created" tab="已发起"> </a-tab-pane>
                <a-tab-pane key="deposit" tab="已首款"> </a-tab-pane>
                <a-tab-pane key="retainage" tab="已尾款"> </a-tab-pane>
                <a-tab-pane key="complete" tab="已完成/已取消"> </a-tab-pane>
            </a-tabs>
            <a-spin tip="加载中" :spinning="loading">
                <div class="orders">
                    <section class="order" v-for="item in data_source" :key="item.order_no">
                        <div class="head">
                            <div class="date">
                                <span
                                    v-html="$options.filters['friendly'](moment(item.created_at * 1000).format('YYYY-MM-DD HH:mm'))"
                                ></span>
                            </div>

                            <div class="order-no">
                                订单号：
                                <router-link :to="`/order/${item.order_no}`" target="_blank">{{ item.order_no }}</router-link>
                            </div>
                        </div>
                        <div class="body">
                            <div class="status">
                                {{ item.step_text }}
                            </div>
                            <div class="trademark">
                                <div class="thumb">
                                    <img
                                        style="width:64px;height:64px"
                                        v-lazy="item.trademark.logo"
                                        onerror="this.src='https://scxm.oss-cn-hangzhou.aliyuncs.com/assets/images/img_missing.png'"
                                    />
                                </div>
                                <div class="detail">
                                    <div class="name">
                                        <a :href="item.trademark.release_url" target="_blank"> {{ item.trademark.markName }} </a>
                                    </div>
                                    <div class="name-b">{{ item.trademark.internationalGroup }}类</div>
                                    <div class="name-b">商标号：{{ item.apply_no }}</div>
                                </div>
                            </div>

                            <div class="amount">
                                <div class="lirun">
                                  原价：<span>¥{{ item.trademark.price }}</span><br>
                                  售价：<span>¥{{ item.amount }}</span><br>
                                  差额：<span>¥{{ (item.amount - item.trademark.price*0.7).toFixed(0) }}</span>
                                </div>
                            </div>

                          <div class="buyer">
                            <div class="item">
                              <div class="name">
                                {{ item.member.name }}
                                <span class="id">（ID：{{ item.member.id }}）</span>
                              </div>
                               <div class="com">{{ item.member.com_name }}</div>
                              <div class="corner buy">客户信息 </div>
                            </div>
                          </div>

                          <div class="buyer-amount">
                            <div class="corner">销售信息</div>
                            <table class="b-table">
                              <tbody>
                              <tr>
                                <td width="30">姓名</td>
                                <td>{{ item.user.name }}</td>
                              </tr>
                              <tr>
                                <td>部门</td>
                                <td>{{ item.user.group.name }}</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>

                            <div class="buyer-amount">
                                <div class="corner">买家付款</div>

                                <table class="b-table">
                                    <tbody>
                                        <tr>
                                            <td width="30">首款</td>
                                            <td>¥{{ item.amount_deposit }}</td>
                                        </tr>
                                        <tr>
                                            <td>尾款</td>
                                            <td>¥{{ item.amount_retainage }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="action">
                                <a-button @click="redirect(`/order/${item.order_no}`)" size="small">查看</a-button>
                            </div>
                        </div>
                        <div class="foot" v-if="item.remark || item.cancel_msg">
                            <template v-if="item.remark"> <a-icon class="icon" type="info-circle" />{{ item.remark }} </template>

                            <template v-if="item.cancel_msg"> <a-icon type="close-circle" /> {{ item.cancel_msg }} </template>
                        </div>
                    </section>
                </div>
            </a-spin>

            <!-- 分页 -->
            <div class="page" v-if="pagination && pagination.current > 0 && data_source.length">
                <div></div>
                <a-pagination
                    :disabled="loading"
                    v-model="pagination.current"
                    :total="pagination.total"
                    :page-size.sync="pagination.pageSize"
                    show-size-changer
                    showQuickJumper
                    :pageSizeOptions="['20', '50', '100', '200']"
                    @change="(page, pageSize) => on_pagination_change_common(page, pageSize)"
                    :show-total="(total, range) => `${range[0]}-${range[1]} , 展示 ${total} 条，实际 ${pagination.totalReality || '-'} 条`"
                />
            </div>
        </div>

        <a-empty :image="simpleImage" v-if="!loading && !data_source.length" style="margin-top: 96px;">
            <a-button @click="load" icon="reload" style="margin-right:24px;">
                刷新
            </a-button>
            <a-button @click="on_reset" icon="rollback">重置</a-button>
        </a-empty>

        <!-- 创建订单 -->
        <modal_create :visible="visible_create" :callback="load" @close="visible_create = false" />
    </div>
</template>

<script>
    import moment from "moment";
    import common_pagination from "../../../mixins/common_pagination.js";
    import commonjs from "../mixins/common";
    import modal_create from "./modal_create.vue";

    import { Empty } from "ant-design-vue";

    export default {
        mixins: [common_pagination, commonjs],
        beforeCreate() {
            this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
        },
        components: { modal_create },
        data() {
            return {
                path: "/order/whole",
                data_source: [],
                loading: false,
                visible_create: false,
                selected_record: null,
                type: "",
                wd: null,
                apply_no: null,
                search_user_ids: [],
                created_date: null,
            };
        },
        watch: {
            $route() {
                this.reset_query();
                this.load();
            },
        },
        created() {
            this.$store.commit("change_state", {
                name: "sidebar_order",
                value: "order",
            });
            this.reset_query();
            this.load();
        },
        methods: {
            moment,
            reset_query() {
                let query = this.$route.query;
                this.wd = "wd" in query ? query["wd"] : "";
                this.apply_no = "apply_no" in query ? query["apply_no"] : "";
                this.type = "type" in query ? query["type"] : "";
                this.created_date = "created_at" in query ? query["created_at"].split(",") : null;
                this.search_step = "step" in query ? query["step"] : "";
                this.search_user_ids = Object.prototype.hasOwnProperty.call(query, "user_id") ? query["user_id"].split(",") : [];
            },
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/order_trademark/whole?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };
                        } else {
                            this.data_source = [];
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            on_edit(row) {
                this.selected_record = row;
                this.mode_create = "edit";
                this.visible_create = true;
            },
            on_create() {
                this.selected_record = {};
                this.visible_create = true;
            },
            on_delete(record) {
                this.$confirm({
                    centered: true,
                    title: "删除确认",
                    content: `是否删除【${record.name}】`,
                    loading: true,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            this.$http
                                .delete("/order_trademark/" + record.id)
                                .then((res) => {
                                    if (!res.success) {
                                        this.$error({
                                            title: "失败",
                                            content: res.message,
                                        });
                                    } else {
                                        this.load();
                                    }
                                })
                                .catch(() => {})
                                .then(() => {
                                    resolve();
                                });
                        }).catch();
                    },
                });
            },
            on_type_change(e) {
                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                new_query["type"] = e.target.value;
                this.$router.push(this.path + "?" + this.objectToQuery(new_query));
            },
            on_created_change(date) {
                this.on_field_change(date.join(","), "created_at");
            },
        },
    };
</script>

<style lang="less" scoped>
    .container {
        /deep/.ant-tabs-bar {
            margin: 0 !important;
        }
        .action {
            width: 120px;
        }
        .sort {
            display: flex;
            justify-content: space-around;
        }
        // .order {
        //     .description {
        //         font-size: 12px;
        //         color: #00000080;
        //     }
        // }

        .weikuan {
            color: #999;
            font-size: 12px;
            .ph {
                height: 2px;
                width: 24px;
                background: #999;
                margin-top: 4px;
                margin-bottom: 4px;
            }
        }
        .cancel-msg {
            color: #ff9800;
            font-size: 12px;
            .ph {
                height: 1px;
                width: 24px;
                background: #ff9800;
                margin-top: 4px;
                margin-bottom: 4px;
            }
        }
        .participant {
            .a {
                font-size: 12px;
            }
        }
        .remark {
            font-size: 12px;
        }
        .ant-progress {
            /deep/.ant-progress-text {
                font-size: 12px;
            }
        }

        .orders {
            min-height: 200px;
            .order {
                border: 1px solid #e8e8e8;
                margin: 16px;
                border-radius: 5px;
                overflow: hidden;
                &:hover {
                    box-shadow: 0 6px 16px -8px #00000014, 0 9px 28px 0 #0000000d, 0 12px 48px 16px #00000008;
                }
                .head {
                    padding: 8px 16px;
                    display: flex;
                    align-items: center;
                    background: #f1f1f1;
                    .date {
                        margin-right: 24px;
                        color: #9e9e9e;
                        min-width: 120px;
                    }
                }
                .body {
                    display: flex;
                    .status {
                        min-width: 70px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-right: 1px solid #efefef;
                        font-weight: bold;
                    }
                    .trademark {
                        display: flex;
                        align-items: center;
                        border-right: 1px solid #efefef;
                        min-width: 250px;
                        width: 100%;

                        .thumb {
                            margin-right: 12px;
                            text-align: center;
                            margin-left: 12px;
                        }
                        .detail {
                            padding: 16px;
                            .name {
                                font-size: 14px;
                                margin-bottom: 2px;
                            }
                            .name-b {
                                font-size: 12px;
                            }
                        }
                    }
                    .buyer {
                        padding: 16px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        border-right: 1px solid #efefef;
                        min-width: 250px;
                        position: relative;
                        .item {
                            .name {
                                margin-bottom: 2px;
                                font-size: 12px;
                                .id {
                                    font-weight: normal;
                                }
                            }
                            .id,
                            .com,
                            .balance {
                                font-size: 12px;
                                color: #11111180;
                            }
                            .corner {
                                position: absolute;
                                right: 0;
                                width: 68px;
                                height: 24px;
                                background: #fafafa;
                                color: #00000073;
                                font-size: 12px;
                                text-align: center;
                                line-height: 24px;
                                &.buy {
                                    top: 0;
                                }
                                &.sell {
                                    bottom: 0;
                                }
                            }
                        }
                        .divider {
                            height: 1px;
                            background: #efefef;
                            margin: 4px 0;
                        }
                    }
                    .user {
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        align-items: center;
                        padding: 16px;
                        border-right: 1px solid #efefef;
                        min-width: 120px;
                        .name {
                        }
                        .group {
                            font-size: 12px;
                            color: #11111180;
                        }
                    }
                    .amount {
                        margin: 16px;
                        min-width: 130px;
                        border-right: 1px solid #efefef;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        .price {
                            font-size: 16px;
                            font-weight: bold;
                        }
                        .lirun {
                            font-size: 12px;
                            span {
                                color: red;
                            }
                        }
                    }
                    .buyer-amount {
                        min-width: 130px;
                        padding: 16px;
                        border-right: 1px solid #efefef;
                        position: relative;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        .corner {
                            position: absolute;
                            right: 0;
                            top: 0;
                            height: 24px;
                            padding: 0 8px;
                            background: #fafafa;
                            color: #00000073;
                            font-size: 12px;
                            text-align: center;
                            line-height: 24px;
                        }
                    }
                    .seller-amount {
                        min-width: 130px;
                        padding: 16px;
                        position: relative;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        .corner {
                            position: absolute;
                            right: 0;
                            top: 0;
                            height: 24px;
                            padding: 0 8px;
                            background: #fafafa;
                            color: #00000073;
                            font-size: 12px;
                            text-align: center;
                            line-height: 24px;
                        }
                    }
                    .action {
                        min-width: 80px;
                        border-left: 1px solid #efefef;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
                .foot {
                    background: #fffbe6;
                    padding: 4px 16px;
                    font-size: 12px;
                    .icon {
                        margin-right: 8px;
                    }
                }
            }
        }

        .page {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px;
            .tips {
                font-size: 12px;
                color: #9e9e9e;
            }
        }
    }
</style>
